import { datadogLogs } from "@datadog/browser-logs";

import useImmediateEffect from "@/hooks/useImmediateEffect";
import {
  getLoggingSampleSessionRate,
  isLoggingEnabled,
  versionForDatadog,
} from "@/monitoring/utils";
import getApplicationEnvironment from "@/utils/getApplicationEnvironment";

import useDatadogUserProperties from "../useDatadogUserProperties";

const BrowserLogging = () => {
  useImmediateEffect(() => {
    if (!globalThis.window) return;
    const { environment } = getApplicationEnvironment();
    if (isLoggingEnabled()) {
      // Comprehensive list of init parameters https://docs.datadoghq.com/logs/log_collection/javascript/#initialization-parameters
      datadogLogs.init({
        clientToken: process.env["NEXT_PUBLIC_DATADOG_TOKEN"] ?? "",
        env: environment,
        site: "datadoghq.com",
        version: versionForDatadog,
        service: "lyceum",
        forwardErrorsToLogs: false,
        sessionSampleRate: getLoggingSampleSessionRate(),
      });
    }
  }, []);

  const datadogUserProperties = useDatadogUserProperties();

  useImmediateEffect(() => {
    if (!globalThis.window) return;
    datadogLogs.setUser(datadogUserProperties);
  }, [datadogUserProperties]);

  return null;
};

export default BrowserLogging;
